// extracted by mini-css-extract-plugin
export default {"container":"vR46ffwsqKztTamu_CHz","item":"w3IBPGeVMr5nUkXxy_4R","bottomBar":"qlyFQxknrQ2jSO6FPkmw"};